import React from 'react';
import { FaFileAlt, FaMobileAlt, FaPlug, FaChartBar, FaCogs, FaTools } from 'react-icons/fa';

const services = [
    {
        title: 'Custom Software Solutions',
        icon: <FaCogs size={48} style={{ color: '#6d4c41' }} />, // brown
        desc: 'Bespoke software solutions to solve unique business challenges.'
    },
    {
        title: 'Mobile & Web Application Development',
        icon: <FaMobileAlt size={48} style={{ color: '#1976d2' }} />, // blue
        desc: 'Custom mobile and web apps tailored to your business needs.'
    },
    {
        title: 'API Integration & Consulting',
        icon: <FaPlug size={48} style={{ color: '#ff9800' }} />, // orange
        desc: 'Seamless integration of APIs and expert consulting for digital transformation.'
    },
    {
        title: 'Data Analytics & Reporting',
        icon: <FaChartBar size={48} style={{ color: '#43a047' }} />, // green
        desc: 'Transform data into actionable insights with analytics and reporting.'
    },
    {
        title: 'Technical Support & Maintenance',
        icon: <FaTools size={48} style={{ color: '#e53935' }} />, // red
        desc: 'Reliable technical support and maintenance for your digital assets.'
    },
    {
        title: 'Digital Document Management',
        icon: <FaFileAlt size={48} style={{ color: '#009688' }} />, // teal
        desc: 'Secure and efficient management of digital documents for your organization.'
    },
];

const Services = () => (
    <div className="container py-4">
        <h2 className="mb-4">Our Services</h2>
        <div className="row g-4">
            {services.map((service, idx) => (
                <div className="col-12 col-md-6 col-lg-4" key={idx}>
                    <div className="card h-100 shadow-sm text-center">
                        <div className="card-body d-flex flex-column align-items-center justify-content-center">
                            <div className="mb-3">
                                {service.icon}
                            </div>
                            <h5 className="card-title">{service.title}</h5>
                            <p className="card-text">{service.desc}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
        <p className="mt-4">
            Contact us to learn more about how Vakralabs Services can help your organization with digital transformation.
        </p>
        <p className="mt-2">
            <a href="/pricing" className="fw-bold text-teal text-decoration-underline">Click here for pricing</a>
        </p>
    </div>
);

export default Services;